module.exports = __webpack_public_path__ + "img/csm_expovina_07_web_4195e74d13.bb38c487.jpg";